import React from 'react';
import { Helmet } from 'react-helmet';
import Support from '../components/Support';

const SupportRoute = () => {
  return (
    <>
      <Helmet>
        <title>AskPics — Support</title>
        <meta name="description" content="Get support for AskPics — Search Screenshots and contact our team." />
        <link rel="canonical" href="https://askpics.app/support" />
      </Helmet>
      <div>
        <main>
          <Support />
        </main>
      </div>
    </>
  );
};

export default SupportRoute;
